import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { translate } from "../../../../Components/Lib/Languages/language";
moment.locale("nl");
class Inschrijven extends Component {
  state = {
    errors: {},
    loading: false,
    datum: "",
  };

  render() {

    const { faciliteit } = this.props;

      return (
        <Link
          className="activiteit-link"
          to={{
            pathname: "/public/faciliteit/" + faciliteit._id,
          }}
        >
          <div className="faciliteit-box-body">
            <h3 className="activiteit-titel">{translate(faciliteit.naam)}</h3>
            {translate(faciliteit.beschrijving)}
          </div>
          <div className="activiteit-arrow">
            <i className="fa fa-chevron-right"></i>
          </div>
        </Link>
      );
  }
}

export default Inschrijven;
